import { c as _c } from "react/compiler-runtime";
import { RowTitle } from "./RowTitle";
type DataTableDataRowProps = {
  title?: string;
  titleUrl?: string;
  dataCells: (string | null | undefined)[];
  columnCount: number;
  tableType?: "basic" | "grouped";
};
const cellClasses = ["text-gray-m10 font-normal", "text-base sm:text-lg", "leading-[1.375rem] sm:leading-8", "tracking-normal sm:tracking-[0.18px]", "py-4 px-6", "border-b border-b-gray-m2 border-r border-r-gray-m2 last:border-r-0", "bg-white", "t2-dark:text-white t2-dark:border-b-white t2-dark:bg-transparent"].join(" ");
export const DataRow = t0 => {
  const $ = _c(14);
  const {
    title,
    titleUrl,
    dataCells: t1,
    columnCount,
    tableType
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const dataCells = t2;
  let t3;
  if ($[2] !== columnCount || $[3] !== tableType || $[4] !== title || $[5] !== titleUrl) {
    t3 = tableType !== "grouped" && <RowTitle title={title || ""} titleUrl={titleUrl} columnCount={columnCount} />;
    $[2] = columnCount;
    $[3] = tableType;
    $[4] = title;
    $[5] = titleUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== dataCells) {
    t4 = dataCells?.map(_temp) ?? [];
    $[7] = dataCells;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <tr>{t4}</tr>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
function _temp(cell, index) {
  return <td key={index} className={cellClasses}>{cell ?? "\u2014"}</td>;
}